import React, { useState } from 'react';
import { useSettings } from '../../../contexts/SettingsContext';

const DisplayTab = () => {
  const { settings, updateSettings } = useSettings();
  const [message, setMessage] = useState('');

  const handleChange = async (field, value) => {
    try {
      await updateSettings({ [field]: value });
      // updateSettings zaten state'i güncelliyor, fetchSettings'a gerek yok
      setMessage('Settings updated!');
      setTimeout(() => setMessage(''), 2000);
    } catch (err) {
      setMessage('Update failed');
    }
  };

  if (!settings) return <div>Loading...</div>;

  return (
    <div>
      <div className="tab-section">
        <h3 className="section-title">Label Settings</h3>
        <p className="section-description">
          Configure countdown label text
        </p>

        <div className="toggle-group">
          <span className="toggle-label">Show Label</span>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={settings.show_label}
              onChange={(e) => handleChange('show_label', e.target.checked)}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>

        {settings.show_label && (
          <div className="form-group">
            <label>Label Text</label>
            <input
              type="text"
              value={settings.label_text}
              onChange={(e) => handleChange('label_text', e.target.value)}
              placeholder="e.g., COUNTDOWN TO LAUNCH"
            />
          </div>
        )}
      </div>

      <div className="tab-section">
        <h3 className="section-title">Display Format</h3>
        <p className="section-description">
          Control how numbers are displayed
        </p>

        <div className="toggle-group">
          <span className="toggle-label">Show Breakdown (days/hours/min)</span>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={settings.show_breakdown}
              onChange={(e) => handleChange('show_breakdown', e.target.checked)}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>

        <div className="toggle-group">
          <span className="toggle-label">Leading Zeros</span>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={settings.leading_zeros}
              onChange={(e) => handleChange('leading_zeros', e.target.checked)}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>

        <div className="form-group">
          <label>Number Format</label>
          <select
            value={settings.number_format}
            onChange={(e) => handleChange('number_format', e.target.value)}
          >
            <option value="plain">Plain (12345678)</option>
            <option value="comma">Comma (12,345,678)</option>
          </select>
        </div>

        <div className="form-group">
          <label>Digit Count</label>
          <select
            value={settings.digit_count}
            onChange={(e) => handleChange('digit_count', e.target.value)}
          >
            <option value="auto">Auto</option>
            <option value="6">6 digits</option>
            <option value="8">8 digits</option>
            <option value="10">10 digits</option>
            <option value="12">12 digits</option>
          </select>
        </div>
      </div>

      <div className="tab-section">
        <h3 className="section-title">Particle Effects</h3>
        <p className="section-description">
          Control all particle effects and celebrations
        </p>

        <div className="toggle-group">
          <span className="toggle-label">Enable All Particle Effects</span>
          <label className="toggle-switch">
            <input
              key={`particle-${settings.particle_effects_enabled}`}
              type="checkbox"
              checked={settings.particle_effects_enabled !== false}
              onChange={(e) => {
                const newValue = e.target.checked;
                handleChange('particle_effects_enabled', newValue);
              }}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>

        {settings.particle_effects_enabled !== false && (
          <>
            <div className="toggle-group">
              <span className="toggle-label">Enable Ambient Particles (Background)</span>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.ambient_particles_enabled !== false}
                  onChange={(e) => handleChange('ambient_particles_enabled', e.target.checked)}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>

            {settings.ambient_particles_enabled !== false && (
              <div className="slider-group">
                <div className="slider-label">
                  <span>Ambient Particle Count</span>
                  <span className="slider-value">{settings.ambient_particles_count || 25}</span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="50"
                  value={settings.ambient_particles_count || 25}
                  onChange={(e) => handleChange('ambient_particles_count', parseInt(e.target.value))}
                />
              </div>
            )}

            <div className="toggle-group">
              <span className="toggle-label">Enable Milestone Celebrations</span>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.milestone_celebrations_enabled !== false}
                  onChange={(e) => handleChange('milestone_celebrations_enabled', e.target.checked)}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>

            {settings.milestone_celebrations_enabled !== false && (
              <div className="slider-group" style={{ marginBottom: '12px' }}>
                <div className="slider-label">
                  <span>Celebration Cooldown (Hours)</span>
                  <span className="slider-value">{settings.celebration_cooldown_hours || 6}h</span>
                </div>
                <input
                  type="range"
                  min="1"
                  max="24"
                  value={settings.celebration_cooldown_hours || 6}
                  onChange={(e) => handleChange('celebration_cooldown_hours', parseInt(e.target.value))}
                />
                <p style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
                  Celebrations will only trigger once every {settings.celebration_cooldown_hours || 6} hours
                </p>
              </div>
            )}

            <div className="toggle-group">
              <span className="toggle-label">Enable Final Countdown Effects (Last 10 seconds)</span>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.final_countdown_effects_enabled !== false}
                  onChange={(e) => handleChange('final_countdown_effects_enabled', e.target.checked)}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>

            <div className="toggle-group">
              <span className="toggle-label">Enable Zero Countdown Effects (When countdown reaches 0)</span>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.zero_countdown_effects_enabled !== false}
                  onChange={(e) => handleChange('zero_countdown_effects_enabled', e.target.checked)}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </>
        )}
      </div>

      {message && <div className="success-message">{message}</div>}
    </div>
  );
};

export default DisplayTab;